import {ISvgIconProps, SvgIcon} from "../../../basic-ui-components/icon/svg-icon/svg.icon";
import * as React from "react";

export interface IFreePlayIconProps extends ISvgIconProps {

}

export class FreePlayIcon extends React.Component<IFreePlayIconProps> {
    render() {
        return (
            <SvgIcon size={3.5} viewBox="0 0 52 52" {...this.props}>
                <g stroke="currentColor" strokeWidth="4.0" strokeLinejoin="round" fill="none">
                    <path d="M21.5257 18.47659v29.15264"/>
                    <path strokeLinecap="round" d="M30.03349 6.63872c-1.7776 1.98616-4.87523 12.65519-4.87523 12.65519s9.8344-3.79656 11.61364-5.78448a4.65632 4.97244 0 0 0-6.73677-6.8672l-.00165-.00352z"/>
                    <path d="M8.79779 33.70852v14.06133h33.23944V33.70852"/>
                    <path d="M29.30765 18.47659v29.15264"/>
                    <path strokeLinecap="round" d="M20.79986 6.64048c1.7776 1.98616 4.87523 12.65519 4.87523 12.65519s-9.8311-3.80007-11.61199-5.78799a4.65632 4.97244 0 0 1 6.73677-6.8672z"/>
                    <path d="M29.3093 28.73957h15.447v-9.24884H6.07873v9.24708h15.447"/>
                </g>
            </SvgIcon>
        );
    }
}